<template>
  <section>
    <Account />
    <Intro />
  </section>
</template>

<script>
import Account from './account';
import Intro from './intro';
export default {
  components: {
    Account,
    Intro,
  },
};
</script>

<style>

</style>
